<div class="strength-meter">
    <div class="strength-meter-fill"></div>
    <div class="ion-text-center" [hidden]="!passwordStrengthText">
        <small>{{passwordStrengthText}}</small>
    </div>
</div>